import axios from 'axios';

import { API_BASE_URL } from 'utils/constants';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,

  headers: {
    'Content-Type': 'application/json',
  },
});

export const handleFetchAppslistData = async () => {
  const response = await axiosInstance.get('/admin/apps');

  return response.data;
};

export const handleSaveAppslistData = async (appID, enabled) => {
  const response = await axiosInstance.put(`/admin/apps/${appID}`, { enabled });

  return response.data;
};

export const handlePostAppslistData = async (data) => {
  const response = await axiosInstance.post('/admin/apps', data);

  return response.data;
};

export const handleDeleteAppslistData = async (appID) => {
  const response = await axiosInstance.delete(`/admin/apps/${appID}`);

  return response.data;
};
